export const demoRoles = [
    'Engineering leader',
    'SRE or platform engineer',
    'Software engineer',
    'Something else'
]

export const demoTeamSizes = [
    '1 to 20 engineers',
    '21 to 100 engineers',
    '101 to 500 engineers',
    'More than 500 engineers'
]

export const demoLimits = {
    name: 120,
    company: 120,
    email: 254,
    message: 1500
}
